// eslint-disable-next-line import/prefer-default-export
export const FETCH_USER = 'getUser';
